import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-info-panel',
  standalone: false,
  templateUrl: './info-panel.component.html',
  styleUrl: './info-panel.component.scss',
})
export class InfoPanelComponent {
  @Input() infoTitle: string = '';
  @Input() infoText: string = '';
  @Output() close = new EventEmitter<void>();
  constructor(public labelService: LabelService) {}

  onClose() {
    this.close.emit();
  }
}
